module.exports = __webpack_public_path__ + "img/onlineteacher-logo.0e13ff96.png";